/* eslint-disable */
require('./basket')
require('./calendar')
require('./check-green')
require('./check-white')
require('./check')
require('./close copy')
require('./close')
require('./condense')
require('./expand')
require('./filter')
require('./folder-open')
require('./info')
require('./refresh')
require('./remove-inverted')
require('./remove')
require('./small-triangle-down-black')
require('./small-triangle-down-white')
require('./small-triangle-down')
require('./small-triangle-left')
require('./small-triangle-right')
require('./small-triangle-up')
require('./star')
require('./ticket')
require('./warning-blue')
require('./warning-red')
require('./warning-yellow')
